import { useState } from "react";
import "./hero.scss";
import banner from "../../resources/images/banner.png";
// import Swal from "sweetalert2";
// import Cargar from "../Cargar";
// import Modal from "react-modal";
import Mymodal from "../Modal/Mymodal";
import Cargar from "../Cargar";
import Swal from "sweetalert2";

export const Hero = () => {
  const [estadoModal, setEstadoModal] = useState(false);

  const mostrarIndicaciones = () => {
    Swal.fire({
      html:
        '<div id="fondo">' +
        '<div id="foto"></div>' +
        '<h1 id="colorRecomendacionesMovil" class="futuraBold">' +
        "RECOMENDACIONES</h1>" +
        '<ol class="colorEtiquetaRecomendacionesMovil">' +
        "<li><p>Utiliza un fondo blanco, o tono claro</p></li>" +
        "<li><p>Muestra tu rostro completo y de frente</p></li>" +
        "<li><p>Si posees cabello largo, recógelo</p></li>" +
        "<li><p>Fotografía en formato PNG o JPEG</p></li>" +
        "<li><p>Que sea una fotografía actual</p></li>" +
        "</ol></div>",
      confirmButtonText: "CONTINUAR",
      showConfirmButton: true,
      showCloseButton: true,
    }).then((result) => {
      setEstadoModal(result.isConfirmed);
    });
  };

  return (
    <div
      className="banner container-fluid"
      style={{ background: `url(${banner})` }}
    >
      <Mymodal display={estadoModal}>
        <Cargar />
      </Mymodal>

      <div className="row justify-content-end">
        <div className="side-option col-md-5">
          <div className="d-flex justify-content-center align-items-center flex-column h-100">
            <span className="font-futura-b text-white display-4 mb-4">
              CARNETÍZATE
            </span>
            <button
              className="boton orangeReingreso font-futura-b text-uppercase"
              onClick={() => mostrarIndicaciones()}
            >
              Iniciar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
